module.exports = {
  BASE_URL: "https://qbtest.qbbystudy.com",
};
//1